__turbopack_context__.v({
  "active": "-DTMGG_active",
  "buttonsWrapper": "-DTMGG_buttonsWrapper",
  "close": "-DTMGG_close",
  "collapsedSubmenu": "-DTMGG_collapsedSubmenu",
  "container": "-DTMGG_container",
  "expandBtn": "-DTMGG_expandBtn",
  "expandedSubmenu": "-DTMGG_expandedSubmenu",
  "hide": "-DTMGG_hide",
  "icon": "-DTMGG_icon",
  "logoWrapper": "-DTMGG_logoWrapper",
  "logoWrapperImage": "-DTMGG_logoWrapperImage",
  "navbar": "-DTMGG_navbar",
  "navbarExpanded": "-DTMGG_navbarExpanded",
  "slideIn": "-DTMGG_slideIn",
  "slideUp": "-DTMGG_slideUp",
  "submenu": "-DTMGG_submenu",
});
